<template>
	<div class="solutions-container">
		<h4 class="title font-bold mb-5 pb-4 text-center" v-if="title">{{ title }}</h4>
  	<div class="grid">
      <div class="card" v-for="block in blocks" :key="block.key" :id="block.key" :img="block.img" :title="$t(`solutions.${block.key}.title`)" :description="$t(`solutions.${block.key}.description`)" :action="() => {  }" visible>
				<img :src="block.img" alt="" class="mb-4 icon" />
				<h3 class="text-lg font-semibold">{{ $t(`solutions.${block.key}.title`) }}</h3>
				<p class="text-gray-600">{{ $t(`solutions.${block.key}.description`) }}</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  name: 'Blocks2x2Section',
	props: {
		title: {
			type: String
		}
	},
  data () {
    return {
      blocks: [
        { key: 'qualityMedicine', img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/medic.svg' },
        { key: 'agileAppointment', img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/fast-clock.svg' },
        { key: 'privateConsultations', img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/private-appointments.svg' },
        { key: 'medicineWellbeing', img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/hand-holding-heart.svg' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
	font-size: 35px;
}
.solutions-container {
	@include container-padding;
	padding: 4rem;

	@include mobile {
		padding: 2rem;
	}
}
.grid {
	/* @include desktop {
		padding: 0 min(10rem, 20rem);
	}

	@include desktop-xl {
		padding: 0 min(10rem, 60rem);
	}

	@include tablets {
		padding: 0 5rem;
	} */
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4rem;
}

.card {
  background-color: $white;
  border-radius: $border-radius;
  box-shadow: $custom-shadow;
	padding: 2rem;
  @include desktop {
		padding: 3rem;
	}
  text-align: center;
	border: 0px;

	@include media (desktop) {
		width: 400px;

		&:nth-child(1),
		&:nth-child(3) {
			margin-left: auto; // Apply margin-left 0 auto to the first and third cards
		}
	}

	h3 {
		color: $blue;
		font-size: 1.5rem;
		font-weight: 600;
	}

	p {
		font-size: 1.15rem;
		margin: 0;
		margin-top: 1rem;
	}
}

.icon {
	width: 6rem;
	height: 6rem;
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 1.75rem;
}

@include mobile {
  .grid {
		padding: 0;
    grid-template-columns: 1fr;
    gap: 2rem; /* Adjusting gap for mobile view */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/landing/Blocks2x2Section.vue